module.exports = __webpack_public_path__ + "img/googleplay.c3bba96.svg";